<template>
  <div>
    <div v-if="initialized">
      <!-- filters -->
      <ReportBuilderFilters
        class="mb-4"
        @filtersApplied="refreshReports"
        @preloaded="loading = false"
      />

      <!-- reports -->
      <ReportSection :loading="loading" />
    </div>

    <!-- loader -->
    <div v-else>
      <FullLoader />
    </div>
    <OptionsDrawer @metricsUpdated="refreshReports" />
  </div>
</template>

<script>
import ReportBuilderFilters from './ReportBuilderFilters'
import ReportSection from './ReportSection'
import OptionsDrawer from './OptionsDrawer'
import FullLoader from '@/components/MainContent/FullLoader'
import { createNamespacedHelpers } from 'vuex'

const ReportBuilderModule = createNamespacedHelpers('reportBuilder')
const LocationModule = createNamespacedHelpers('location')
const DataCoreModule = createNamespacedHelpers('dataCore')
const GroupModule = createNamespacedHelpers('group')

export default {
  name: 'ReportBuilderView',
  components: {
    ReportBuilderFilters,
    ReportSection,
    FullLoader,
    OptionsDrawer
  },
  data: () => ({
    loading: true,
    initialized: false,
    activeCustomReportFilters: null
  }),
  async mounted() {
    // ReportBuilderPage is keyed by activeCompany._id, so switching companies destroys and remounts
    // this whole subtree — mount IS the company-switch hook. The Vuex store persists across that
    // remount, so we must clear the previous company's filters/report here. Without the reset,
    // state.filters still holds the prior company's values; when no location is selected the new
    // company's recomputed filters are isEqual to the old ones, applyFilters() short-circuits, and
    // the report never refetches — leaving the previous company's data on screen (OVA-7161).
    this.initialized = false
    this.resetReportBuilder()
    await this.initialize()
    this.initialized = true
  },
  computed: {
    ...DataCoreModule.mapGetters(['selectActiveCompanyIds'])
  },
  methods: {
    ...ReportBuilderModule.mapActions([
      'fetchReportData',
      'fetchCustomReports',
      'resetReportBuilder'
    ]),
    ...LocationModule.mapActions(['getUserLocationsByActiveCompany']),
    ...GroupModule.mapActions(['fetchGroups']),
    async refreshReports() {
      this.loading = true
      await this.fetchReportData()
      this.loading = false
    },
    async initialize() {
      this.loading = true
      // The report fetch itself is driven by the filters component (filtersApplied → refreshReports)
      // once these resolve; initialize() only loads the new company's locations, groups, and custom
      // reports.
      await Promise.all([
        this.getUserLocationsByActiveCompany(),
        this.fetchGroups({
          memberType: 'location',
          companyIds: this.selectActiveCompanyIds
        }),
        this.fetchCustomReports()
      ])
      this.loading = false
    }
  }
}
</script>
